import React, { FC } from 'react'
import { IFileUploadAlert } from '../../interfaces/Upload'

const UploadErrorAlert: FC<{ fileAlert: IFileUploadAlert | null }> = ({
  fileAlert,
}) => {
  if (!fileAlert) {
    return null
  }

  return (
    <div
      className={
        fileAlert.type === 'error' ? 'mt05 colMd12 textRight' : 'colMd6'
      }
    >
      {fileAlert.messageLine2 ? (
        <div
          className={`${fileAlert.type}Alert fontSizeXs py0Md wFull mw28Sm textLeft dInlineBlock`}
        >
          <p className="fontWeightBold fontSizeXxs">{fileAlert.message}</p>
          <p>{fileAlert.messageLine2}</p>
        </div>
      ) : (
        <div className={`${fileAlert.type}Alert fontSizeXs py0Md`}>
          <p>{fileAlert.message}</p>
        </div>
      )}
    </div>
  )
}

export default UploadErrorAlert
